import { render, staticRenderFns } from "./lyrics.vue?vue&type=template&id=77b3c482&scoped=true&"
import script from "./lyrics.vue?vue&type=script&lang=js&"
export * from "./lyrics.vue?vue&type=script&lang=js&"
import style0 from "./lyrics.vue?vue&type=style&index=0&id=77b3c482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b3c482",
  null
  
)

export default component.exports